export class ColorService {
	private colorsId: { colorId: string, color: string }[] = [];

	public randomColor(colorId: string): string {
		const generateRandomValue = () => Math.floor(250 * Math.random());

		const existingColor = this.colorsId.find((elt) => elt.colorId === colorId);

		if (existingColor) {
			return existingColor.color;
		}

		const color = `rgb(${generateRandomValue()}, ${generateRandomValue()}, ${generateRandomValue()})`;

		this.colorsId.push({
			colorId,
			color
		});

		return color;
	}
}

export const ColorServiceInstance = new ColorService();



// WEBPACK FOOTER //
// ./src/shared/services/color.service.ts